import Vue from "vue";
import Router from "vue-router";

import artists from "./artists";
import albums from "./albums";
import tracks from "./tracks";
import genres from "./genres";
import directions from "./directions";
import charts from "./charts";
import user from "./user";
import oauth from "./oauth";
import playlists from "./playlists";
import posts from "./pages";
import errors from "./errors";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...user,
    ...tracks,
    ...albums,
    ...artists,
    ...genres,
    ...charts,
    ...directions,
    ...oauth,
    ...playlists,
    ...posts,
    ...errors
  ],
  scrollBehavior(from, to) {
    if (!(from.query.modal || to.query.modal)) {
      return { x: 0, y: 0 };
    }
  }
});
